module.exports = __webpack_public_path__ + "static/media/Babys-dream-Logo.22fb6d73.svg";